import React from "react";

const AppML_Case_JSONFile = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Case JSONFile</h1>
      <p>This is the AppML Case JSONFile page content.</p>
    </div>
  );
};

export default AppML_Case_JSONFile;
